export default function setSearchFiltersVisibility({
  visibility,
  showSearchFilters,
  hideSearchFilters,
  trackEvent,
  TrackEvents,
}) {
  if (visibility) {
    showSearchFilters();
    document.body.className = 'blockScroll';
    trackEvent(TrackEvents.showFiltersInteractionEvent());
  } else {
    hideSearchFilters();
    document.body.className = '';
    window.scrollTo(0, 0);
    trackEvent(TrackEvents.closeFiltersInteractionEvent());
  }
}



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/setSearchFiltersVisibility.js